import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (
          [401, 403].includes(err.status) &&
          this.authenticationService.userValue
        ) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          this.authenticationService.logout();
        }

        return throwError(() => this.buildErrorMessage(err));
      })
    );
  }

  private buildErrorMessage(err: any): string {
    switch (err.status) {
      case 0:
        return 'Unable to reach the server. Check your internet connection and try again.';
      case 401:
        return 'Your session has expired. Please log in again.';
      case 403:
        return "You don't have permission to do that.";
      case 404:
        return 'The requested item could not be found.';
      case 400:
      case 422:
        return (
          err.error?.message ||
          'Some of the information provided is invalid. Please check the form and try again.'
        );
      default:
        if (err.status >= 500) {
          return 'Something went wrong on our end. Please try again shortly.';
        }
        return (
          err.error?.message || err.statusText || 'An unexpected error occurred.'
        );
    }
  }
}
